import { useAppStore } from "@/store";

const PageLoader = () => {
  const loading = useAppStore((s) => s.loading);
  return (
    <div className={`fixed top-0 left-0 w-full h-1 z-50 ${loading ? "block" : "hidden"}`}>
      <div className="bg-orange-500 h-full animate-progress"/>
    </div>
  );
};

export default PageLoader;